{
    "AUGaHEoj_xzqAz0rBtIfl": {
        "key": "AUGaHEoj_xzqAz0rBtIfl",
        "position": {
            "x": 12,
            "y": 9,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "PxJfDDzLcAXKEsPGryl2s": {
        "key": "PxJfDDzLcAXKEsPGryl2s",
        "position": {
            "x": 13,
            "y": 9,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "pgbTxRKoRzdYpacUnH8uH": {
        "key": "pgbTxRKoRzdYpacUnH8uH",
        "position": {
            "x": 14,
            "y": 9,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "4phu_YP-1F8ebFCRQ1JoO": {
        "key": "4phu_YP-1F8ebFCRQ1JoO",
        "position": {
            "x": 15,
            "y": 9,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "lwV3qBuvfYiCaNiOJqjuh": {
        "key": "lwV3qBuvfYiCaNiOJqjuh",
        "position": {
            "x": 16,
            "y": 9,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "IaGnljI2L0n8SJuLsFf-8": {
        "key": "IaGnljI2L0n8SJuLsFf-8",
        "position": {
            "x": 17,
            "y": 9,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "7zYikdnEPbmSrYxhkpb9v": {
        "key": "7zYikdnEPbmSrYxhkpb9v",
        "position": {
            "x": 13,
            "y": 5,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "3UwFFgJt2SglcBNuMqtb9": {
        "key": "3UwFFgJt2SglcBNuMqtb9",
        "position": {
            "x": 14,
            "y": 5,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "sDPpT_R4jd-wH0akDMt7R": {
        "key": "sDPpT_R4jd-wH0akDMt7R",
        "position": {
            "x": 15,
            "y": 5,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "FpfoC3N8dFfZxcJz4bUSP": {
        "key": "FpfoC3N8dFfZxcJz4bUSP",
        "position": {
            "x": 16,
            "y": 5,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "4mfQ_5sUTuY2-bp5giwjo": {
        "key": "4mfQ_5sUTuY2-bp5giwjo",
        "position": {
            "x": 13,
            "y": 13,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "qk7tQjK0jjVt0L2H4-Kq6": {
        "key": "qk7tQjK0jjVt0L2H4-Kq6",
        "position": {
            "x": 14,
            "y": 13,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "gfcyTIkVdHgs-e0h7-j_D": {
        "key": "gfcyTIkVdHgs-e0h7-j_D",
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "iW9xe0m8nt4trd3r7m_vc": {
        "key": "iW9xe0m8nt4trd3r7m_vc",
        "position": {
            "x": 12,
            "y": 13,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "cYfuVuDsJzjUqC-wmqrMO": {
        "key": "cYfuVuDsJzjUqC-wmqrMO",
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "eobBX2V4EiOkvMQQ0knwq": {
        "key": "eobBX2V4EiOkvMQQ0knwq",
        "position": {
            "x": 15,
            "y": 13,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "8INMzGuFMABK-MYct4tYs": {
        "key": "8INMzGuFMABK-MYct4tYs",
        "position": {
            "x": 16,
            "y": 13,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "8nwT_tuDf_PiN7pVy0Z9X": {
        "key": "8nwT_tuDf_PiN7pVy0Z9X",
        "position": {
            "x": 17,
            "y": 13,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "ttCoNsjOtYO1VF7_cAjEy": {
        "key": "ttCoNsjOtYO1VF7_cAjEy",
        "position": {
            "x": 14,
            "y": 17,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "Wberb-tM5cA4Zi2QMNRme": {
        "key": "Wberb-tM5cA4Zi2QMNRme",
        "position": {
            "x": 13,
            "y": 17,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "751ixa8EB_X5XFigg4-kx": {
        "key": "751ixa8EB_X5XFigg4-kx",
        "position": {
            "x": 12,
            "y": 17,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "prSOnEDzd49BDfzq76vyo": {
        "key": "prSOnEDzd49BDfzq76vyo",
        "position": {
            "x": 14,
            "y": 18,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "Pln-AryJbEUDAiG2mwugc": {
        "key": "Pln-AryJbEUDAiG2mwugc",
        "position": {
            "x": 13,
            "y": 18,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "yyjyDYdMrc_8vDYIaWv35": {
        "key": "yyjyDYdMrc_8vDYIaWv35",
        "position": {
            "x": 15,
            "y": 17,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "YqV9eNLP_7P4y9y0KNYwD": {
        "key": "YqV9eNLP_7P4y9y0KNYwD",
        "position": {
            "x": 16,
            "y": 17,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "MUpSYd6nebh7an1cIzHFP": {
        "key": "MUpSYd6nebh7an1cIzHFP",
        "position": {
            "x": 17,
            "y": 17,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "kwQ2YQ3z0WxDJac8oWVub": {
        "key": "kwQ2YQ3z0WxDJac8oWVub",
        "position": {
            "x": 15,
            "y": 18,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "oiPH3oHEkmnyVlcgNkl8u": {
        "key": "oiPH3oHEkmnyVlcgNkl8u",
        "position": {
            "x": 16,
            "y": 18,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "k6UBRgVCU5reO2a63AFWA": {
        "key": "k6UBRgVCU5reO2a63AFWA",
        "position": {
            "x": 11,
            "y": 21,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "YIAJ-ldLpkQqvtjTqvYAi": {
        "key": "YIAJ-ldLpkQqvtjTqvYAi",
        "position": {
            "x": 12,
            "y": 21,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "d-oI4h3Cbu7BIf9x3ViVF": {
        "key": "d-oI4h3Cbu7BIf9x3ViVF",
        "position": {
            "x": 13,
            "y": 21,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "GEvwqdfrWIaWGz3tNxJdX": {
        "key": "GEvwqdfrWIaWGz3tNxJdX",
        "position": {
            "x": 14,
            "y": 21,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "TMrBaAspEKTvKdzLGB2jJ": {
        "key": "TMrBaAspEKTvKdzLGB2jJ",
        "position": {
            "x": 15,
            "y": 21,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "1yEqKsTtPcKGBnDMJVvPN": {
        "key": "1yEqKsTtPcKGBnDMJVvPN",
        "position": {
            "x": 16,
            "y": 21,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "wiTr5SuVf9RoNvm7BBVci": {
        "key": "wiTr5SuVf9RoNvm7BBVci",
        "position": {
            "x": 17,
            "y": 21,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "xYZBUcaJuHx9VoNGgxe_T": {
        "key": "xYZBUcaJuHx9VoNGgxe_T",
        "position": {
            "x": 18,
            "y": 21,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "_rrjmIHvpssZI4LBFOI-V": {
        "key": "_rrjmIHvpssZI4LBFOI-V",
        "position": {
            "x": 14,
            "y": 22,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "gBiYHfKL5p7SyQsEboOFs": {
        "key": "gBiYHfKL5p7SyQsEboOFs",
        "position": {
            "x": 15,
            "y": 22,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "IZn-4FnIe7PUyQCTilvdq": {
        "key": "IZn-4FnIe7PUyQCTilvdq",
        "position": {
            "x": 11,
            "y": 9,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "0KVp1SeyVSzw7IWyXA1VA": {
        "key": "0KVp1SeyVSzw7IWyXA1VA",
        "position": {
            "x": 18,
            "y": 9,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "IvYBJipPxSnEgtlPFq7ey": {
        "key": "IvYBJipPxSnEgtlPFq7ey",
        "position": {
            "x": 13,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "FdjHvvRWAiMG1UNj6CirR": {
        "key": "FdjHvvRWAiMG1UNj6CirR",
        "position": {
            "x": 16,
            "y": 14,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "G4CwaOY-nXyAYplJOu6NI": {
        "key": "G4CwaOY-nXyAYplJOu6NI",
        "position": {
            "x": 12,
            "y": 18,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "PevBCNwkqTa-nGxAU3ais": {
        "key": "PevBCNwkqTa-nGxAU3ais",
        "position": {
            "x": 17,
            "y": 18,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "xLqVHRCrr9W5xChF1ZopK": {
        "key": "xLqVHRCrr9W5xChF1ZopK",
        "position": {
            "x": 13,
            "y": 22,
            "z": 1
        },
        "tag": "spawnspot"
    },
    "6p0MnSxBEBdtvhs-cpVze": {
        "key": "6p0MnSxBEBdtvhs-cpVze",
        "position": {
            "x": 16,
            "y": 22,
            "z": 1
        },
        "tag": "spawnspot"
    }
}